/**
 * Modules/Tooltip - Example Module implementation for tooltips
 *
 * EXAMPLE IMPLEMENTATION: Demonstrates Module pattern with:
 * - Dynamic positioning (top, right, bottom, left)
 * - Image support in tooltips
 * - Dimension checking and wrapping
 * - DOM manipulation and styling
 *
 * Use as reference when creating custom modules with dynamic positioning.
 *
 * INTEGRATION: Automatically triggered by data-tooltip-text attributes on elements.
 * See Module.js listeners for automatic tooltip spawning.
 *
 * @class Modules/Tooltip
 * @extends Module
 *
 * @param {Object} setup - Configuration
 * @param {string} [setup.type='message'] - Tooltip type
 * @param {string} [setup.message=''] - Tooltip message text
 * @param {string} [setup.direction] - Positioning: 'top', 'right', 'bottom', 'left'
 * @param {string} [setup.image] - Optional image URL
 *
 * @example
 * // Automatic tooltip via markup
 * <button data-tooltip-text="Click here" data-tooltip-position="top">
 *     Button
 * </button>
 *
 * @example
 * // Manual tooltip creation
 * App.spawnTooltip({
 *     message: 'Helpful hint',
 *     direction: 'top',
 *     target: buttonElement
 * });
 */
define("Modules/Tooltip", [`Module`, `module`], (Super, Self) => {
	return Super.inherit({
		namespace: Self.id,
		requires: [`XHR`],
		defaults: {
			type: `message`,
			message: ``,
		},
		constructor(setup) {
			const { direction, image, message, type } = setup;
			return this.update({ type, message, image, direction });
		},
		api: {
			/**
			 * @method Modules/Tooltip#update
			 * @param {AsyncOptions} options
			 */
			update: {
				async: true,
				public: true,
				async value(context, options) {
					const { XHR, container, data } = this;
					const { direction, image, message: textMessage, type } = options;
					const message = textMessage.replace(/\n/gi, `<br />`);

					// replace encoded linebreaks with html ones
					if (message === data.message) {
						// the new message matches the existing message
						return this.checkDimensions();
					}

					data.message = message;
					this.render();

					if (this.isString(image, 1)) {
						const contentWrapper = this.get(`div`);

						// delay the process to load the image to be displayed
						const imageElement = await XHR.loadImage({ src: image });

						// image element is ready, append it to the tooltip
						contentWrapper.appendChild(imageElement);
					}

					if (this.isString(type, 1)) {
						container.setAttribute(`message-type`, type);
					}

					if (!this.hasClass(direction)) {
						this.removeClass(`top right bottom left`);
						this.addClass(direction);
					}

					// check the dimensions again after a buffer period, in case the content is changed for localization
					this.defer({ duration: 500, then: this.checkDimensions });

					// check the dimensions, to see whether wrapping is necessary
					return this.checkDimensions();
				},
			},

			/**
			 * @method Modules/Tooltip#checkDimensions
			 */
			checkDimensions: {
				async: true,
				async value(options) {
					const { DOM, container } = this;
					const { body } = document;
					const testElement = document.createElement(`div`);

					testElement.className = `Module Tooltip test`;
					testElement.style.cssText = `position:absolute;top:-10000px;display:block; opacity:0; z-index:-100;`;
					testElement.innerHTML = container.innerHTML;

					body.appendChild(testElement);

					// any image should be cached, give time to place it
					await this.defer({ duration: 50 });

					// check the dimensions on the test element
					const testDimensions = DOM.getDimensions(testElement);
					const { width: containerWidth } = testDimensions;
					const testWrapper = this.get(`div`, testElement);
					const { offsetWidth } = testWrapper; // Grab the content width
					const contentWidth = offsetWidth + 20; // Add a buffer for safety

					if (contentWidth > containerWidth) {
						this.addClass(`wrap`);
					} else {
						this.removeClass(`wrap`);
					}

					DOM.remove(testElement);
				},
			},
		},
	});
});

define("Modules/Tooltip.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/Tooltip/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"message") : depth0), depth0)) != null ? stack1 : "");
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"message") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":6},"end":{"line":1,"column":41}}})) != null ? stack1 : "")
    + " </div> "
    + container.escapeExpression(lookupProperty(helpers,"getIcon").call(alias1,"diamond",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":49},"end":{"line":1,"column":70}}}));
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Tooltip.js.map